import {
  SCROLL_TO_RESULTADO_ID,
  ScrollableFieldsConfig,
} from '@mchat-rf/consulta-seguimento/hooks/useConsultaSeguimentoAutoScroll'
import { isEmpty } from 'bold-ui'

import { ConsultaSeguimentoPergunta09Model } from './model-consultaSeguimentoPergunta09'
import { hasPergunta09TrazPraVoceAnySim, isPergunta09TrazPraVoceAllNao } from './utils-consultaSeguimentoPergunta09'

export const PERGUNTA_09_SCROLL_CONFIG: ScrollableFieldsConfig<ConsultaSeguimentoPergunta09Model> = {
  PERGUNTA_09_HEADER: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: 'PERGUNTA_09_TRAZ_PRA_VOCE',
      },
    ],
  },
  PERGUNTA_09_TRAZ_PRA_VOCE: {
    scrollConditions: [
      {
        if: (_, allValues) => isPergunta09TrazPraVoceAllNao(allValues),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
      {
        if: (_, allValues) => hasPergunta09TrazPraVoceAnySim(allValues),
        scrollTo: 'PERGUNTA_09_SO_PARA_MOSTRAR',
      },
    ],
    isList: true,
    dependsOn: 'PERGUNTA_09_HEADER',
  },
  PERGUNTA_09_SO_PARA_MOSTRAR: {
    scrollConditions: [
      {
        if: (value) => !isEmpty(value),
        scrollTo: SCROLL_TO_RESULTADO_ID,
      },
    ],
    dependsOn: 'PERGUNTA_09_TRAZ_PRA_VOCE',
  },
}
